import { createBaseThemeVariation } from './base';
export const BBOdysseyTheme = createBaseThemeVariation({
    name: 'bbodyssey',
    brandColor: 'hsla(319, 100%, 18%, 1)',
});
